import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const el = e.target;
      if (!el || el.tagName !== "IMG" || el.dataset.retry || el.dataset.pagespeedNoTransform) return;
      const src = el.currentSrc || el.src;
      if (!src) return;
      el.dataset.retry = "1";
      window.setTimeout(() => {
        const clean = src.replace(/([?&])r=\d+/, "").replace(/[?&]$/, "");
        el.src = `${clean}${clean.includes("?") ? "&" : "?"}r=${Date.now()}`;
      }, 450);
    },
    true
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
